import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=70101a2a"
import script from "./refund.vue?vue&type=script&lang=js"
export * from "./refund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70101a2a')) {
      api.createRecord('70101a2a', component.options)
    } else {
      api.reload('70101a2a', component.options)
    }
    module.hot.accept("./refund.vue?vue&type=template&id=70101a2a", function () {
      api.rerender('70101a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/base-data/after-sales-reason/refund.vue"
export default component.exports